import { render } from "./WebCardModal.vue?vue&type=template&id=5b18957c&scoped=true"
import script from "./WebCardModal.vue?vue&type=script&lang=js"
export * from "./WebCardModal.vue?vue&type=script&lang=js"

import "./WebCardModal.vue?vue&type=style&index=0&id=5b18957c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b18957c"]])

export default __exports__